// removed by extract-text-webpack-plugin
module.exports = {"root":"_23UJ__23","loader":"_1r0B__1r","load":"_2uwye_2u","local":"Ipf8L_Ip"};


//////////////////
// WEBPACK FOOTER
// ./src/shared/components/Loader/Loader.css
// module id = 483
// module chunks = 0